import Lenis from 'lenis';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export const lenis = new Lenis({
    duration: 0.8,
});

// Sync ScrollTrigger with Lenis
lenis.on('scroll', ScrollTrigger.update);

// Update Lenis using GSAP ticker instead of a standalone requestAnimationFrame
gsap.ticker.add((time) => {
    lenis.raf(time * 1000);
});

gsap.ticker.lagSmoothing(0);

export function raf() {
    // Handled by GSAP ticker now
}
